import { Component, OnInit, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  CustomResultOfPaginatedListOfGetResellerTargetsWithPaginationDto,
  GetEnumValuesDto,
  GetResellerTargetByIdDto,
  GetResellerTargetsWithPaginationDto,
  PaginatedListOfGetResellerTargetsWithPaginationDto,
} from 'src/app/core/api/models';
import { ResellerTargetService } from 'src/app/core/api/services';
import { AppFontSize } from 'src/app/core/types/app-font-size.type';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { FormPageConfig } from './../../../core/models/form-page-config.model';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { ResellersTargetFormComponent } from "./resellers-target-form/resellers-target-form.component";

@Component({
    selector: 'app-resellers-target',
    templateUrl: './resellers-target.component.html',
    imports: [BaseIndexModule, ResellersTargetFormComponent]
})
export class ResellersTargetComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = 'resellersTarget';
  modelWithPagination$: Observable<PaginatedListOfGetResellerTargetsWithPaginationDto>;
  items$: Observable<Array<GetResellerTargetsWithPaginationDto>>;
  formPageConfig: FormPageConfig<GetResellerTargetByIdDto> = {};
  form: FormGroup;

  /* Binding service endpoints */
  protected currentService = inject(ResellerTargetService);
  paginationApiMethodName: string = this.currentService.resellerTargetGetResellerTargetsWithPagination.name;
  createGetApiMethodName: string = this.currentService.resellerTargetCreateGet.name;
  deleteApiMethodName: string = this.currentService.resellerTargetDelete.name;
  auditApiMethodName: string = this.currentService.resellerTargetGetResellerTargetAuditWithPagination.name;
  /* Binding service endpoints */

  ResellerTargetTimesEnumValues: GetEnumValuesDto[] = [];

  fontSize: AppFontSize = 'sm';

  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.pageConfig.showHeader = false;
  }

  getEnumsValues() {
    this.getEnumValuesApi('ResellerTargetTimes')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.ResellerTargetTimesEnumValues = values));
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: this.localizer.userName,
        name: 'userName',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}times`,
        name: 'times',
        hasSearch: true,
        type: 'enum',
        enumName: 'ResellerTargetTimes',
      },
      {
        title: `${this.tableVocabs}targetValue`,
        name: 'targetValue',
        hasSearch: true,
        type: 'number',
      },
      {
        title: `${this.tableVocabs}credit`,
        name: 'credit',
        hasSearch: true,
        type: 'number',
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api

  //Get ById
  baseGetByIdApi(id: number): void {
    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .resellerTargetUpdateGet({ id: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  //#endregion
}
